(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2675],{

/***/ 96418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59830);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Currency_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45020);
/* harmony import */ var _Currency_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Currency_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);





var colors = {
    primary: "#007AFF",
    white: "#ffffff",
    black: "#000000"
};
var Currency = function(param) {
    var currency = param.currency, _color = param.color, color = _color === void 0 ? "primary" : _color, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var isFiat = _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CURRENCY */ .wA === "FIAT";
    var isToken = _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CURRENCY */ .wA === "TOKEN";
    if (isFiat) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: currency
    });
    if (isToken) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: size.toString(),
            height: size.toString(),
            viewBox: "0 0 ".concat(size, " ").concat(size),
            fill: "none",
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Currency_module_css__WEBPACK_IMPORTED_MODULE_4___default().svg), className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: (size / 2).toString(),
                cy: (size / 2).toString(),
                r: size * 0.375,
                stroke: colors[color],
                strokeWidth: (size / 4).toString()
            })
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Currency);


/***/ }),

/***/ 48367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ErrorTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64074);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_misc_module_css__WEBPACK_IMPORTED_MODULE_2__);



function ErrorTag(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_2___default().error),
        children: message
    });
}


/***/ }),

/***/ 14389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_footer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65787);
/* harmony import */ var styles_footer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_footer_module_css__WEBPACK_IMPORTED_MODULE_3__);




function CryptoFooter(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().space)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().footer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        "CryptoSports Pty Ltd. All Rights Reserved, 2024.",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/privacy",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Privacy Policy."
                        }),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/terms",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Terms of Service."
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CryptoFooter);


/***/ }),

/***/ 75877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IsLoggedOutWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styles_layout_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1389);
/* harmony import */ var styles_layout_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styles_layout_module_css__WEBPACK_IMPORTED_MODULE_4__);





function IsLoggedOutWrapper(param) {
    var children = param.children;
    // ensure that when logged in, certain pages are inaccessible [/login, /signup/*]
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(), data = ref.data, status = ref.status;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var path = router.asPath;
        if ((path.startsWith("/login") || path.startsWith("/signup") || path === "/") && status === "authenticated" && (data === null || data === void 0 ? void 0 : data.user)) {
            if (path.startsWith("/login") && router.query.from && router.query.from.startsWith("/")) {
                router.push(router.query.from);
            } else {
                router.push("/home");
            }
        }
    }, [
        router.asPath,
        data
    ]);
    if (status !== "unauthenticated") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_layout_module_css__WEBPACK_IMPORTED_MODULE_4___default().page),
        children: children
    });
}


/***/ }),

/***/ 49864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86501);
/* harmony import */ var _styles_toast_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(769);
/* harmony import */ var _styles_toast_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_toast_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59417);






var Toast = function(param) {
    var _message = param.message, message = _message === void 0 ? "" : _message, _children = param.children, children = _children === void 0 ? null : _children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_toast_module_css__WEBPACK_IMPORTED_MODULE_4___default().toastContainer),
        children: [
            children ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faClose */ .YIN,
                className: (_styles_toast_module_css__WEBPACK_IMPORTED_MODULE_4___default().closeIcon),
                onClick: function() {
                    return react_hot_toast__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dismiss */ .ZP.dismiss();
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Toast);


/***/ }),

/***/ 15808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "El": function() { return /* binding */ BlueButton; },
/* harmony export */   "ZP": function() { return /* binding */ Button; },
/* harmony export */   "on": function() { return /* binding */ SlimButton; },
/* harmony export */   "xE": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64074);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3__);








/**
 *
 * @param {object} props
 * @returns
 */ function Button(param) {
    var onClick = param.onClick, text = param.text, _disabled = param.disabled, disabled = _disabled === void 0 ? undefined : _disabled, _className = param.className, className = _className === void 0 ? "" : _className, _variant = param.variant, variant = _variant === void 0 ? "full" : _variant, _type = param.type, type = _type === void 0 ? "button" : _type, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, iconSrc = param.iconSrc, outline = param.outline;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: type,
        onClick: onClick,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().button), className, variant === "fit" ? (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().button_fit) : "", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().hasIcon), Boolean(iconSrc)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().isOutline), Boolean(outline)), _obj)),
        disabled: disabled,
        children: [
            iconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: iconSrc,
                height: iconSize,
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().buttonIcon),
                alt: "logo"
            }),
            text
        ]
    });
}
/**
 *
 * @param {*} props
 * @returns
 */ function SlimButton(_param) {
    var className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    /** @ts-ignore */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().slimButton), className)
    }, rest));
}
/**
 * left arrow button
 */ function BackButton(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _text = _param.text, text = _text === void 0 ? "" : _text, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "text"
    ]);
    return /** @ts-ignore */ /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().backButton), className),
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/icons/left-arrow.png",
                    className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().backIcon)
                }),
                text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: text
                })
            ]
        })
    }));
}
/**
 * bleu button
 */ function BlueButton(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    /** @ts-ignore */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().blueButton), className)
    }));
}


/***/ }),

/***/ 99876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "ZP": function() { return /* binding */ LabelInput; },
/* harmony export */   "yx": function() { return /* binding */ LabelCurrencyInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96418);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64074);
/* harmony import */ var styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3__);








function LabelInput(param) {
    var _label = param.label, label = _label === void 0 ? "" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _type = param.type, type = _type === void 0 ? "text" : _type, _inputOptions = param.inputOptions, inputOptions = _inputOptions === void 0 ? {} : _inputOptions, value = param.value, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onChange = param.onChange, onChange = _onChange === void 0 ? function(val, e) {} : _onChange, _onBlur = param.onBlur, onBlur = _onBlur === void 0 ? function(e) {} : _onBlur, _onFocus = param.onFocus, onFocus = _onFocus === void 0 ? function(e) {} : _onFocus;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputGroup),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputLabel),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, inputOptions), {
                type: type,
                placeholder: placeholder,
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().input),
                onChange: function(e) {
                    onChange(e.target.value, e);
                },
                onBlur: onBlur,
                onFocus: onFocus,
                value: value,
                disabled: disabled
            }))
        ]
    });
}
function LabelCurrencyInput(param) {
    var _label = param.label, label = _label === void 0 ? "" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _type = param.type, type = _type === void 0 ? "text" : _type, _inputOptions = param.inputOptions, inputOptions = _inputOptions === void 0 ? {} : _inputOptions, value = param.value, _borderless = param.borderless, borderless = _borderless === void 0 ? false : _borderless, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _onChange = param.onChange, onChange = _onChange === void 0 ? function(val, e) {} : _onChange, _onBlur = param.onBlur, onBlur = _onBlur === void 0 ? function(e) {} : _onBlur, _onFocus = param.onFocus, onFocus = _onFocus === void 0 ? function(e) {} : _onFocus, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputGroup),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputLabel),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputWithIcon),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Currency__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, inputOptions), {
                        type: type,
                        placeholder: placeholder,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().input), (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputCurrency), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().borderless), borderless)),
                        onChange: function(e) {
                            onChange(e.target.value, e);
                        },
                        onBlur: onBlur,
                        onFocus: onFocus,
                        value: value,
                        disabled: disabled
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputSubtitle),
                children: subtitle
            })
        ]
    });
}
function Input(param) {
    var _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _type = param.type, type = _type === void 0 ? "text" : _type, _inputOptions = param.inputOptions, inputOptions = _inputOptions === void 0 ? {} : _inputOptions, value = param.value, _onChange = param.onChange, onChange = _onChange === void 0 ? function(e) {} : _onChange;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().inputGroup),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, inputOptions), {
            type: type,
            placeholder: placeholder,
            /** @ts-ignore */ className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((styles_misc_module_css__WEBPACK_IMPORTED_MODULE_3___default().input), inputOptions === null || inputOptions === void 0 ? void 0 : inputOptions.className),
            onChange: function(e) {
                return onChange(e.target.value);
            },
            value: value
        }))
    });
}


/***/ }),

/***/ 93910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewAccount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _fields_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15808);
/* harmony import */ var components_fields_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99876);
/* harmony import */ var styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61580);
/* harmony import */ var styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38431);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40636);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6758);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _ErrorTag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48367);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _services_users__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52694);














/**
 * New account Form
 * @param {Object} props
 * @returns
 */ function NewAccount(param) {
    var onSubmit = param.onSubmit;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isValidating = _$ref[0], setIsValidating = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isReferralCodeValid = _$ref1[0], setIsReferralCodeValid = _$ref1[1];
    var submitForm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(values) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                return [
                    2,
                    onSubmit && onSubmit(values)
                ];
            });
        });
        return function submitForm(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var debouncedReferralCodeValidation = (0,lodash__WEBPACK_IMPORTED_MODULE_8__.debounce)(function(code, setFieldError) {
        if (code === "") {
            setIsReferralCodeValid(true);
            return true;
        }
        // Send request only if within the pattern
        if (code.length === referralCodeLength || code.match(referralCodePattern)) {
            setIsValidating(true);
            try {
                (0,_services_users__WEBPACK_IMPORTED_MODULE_9__/* .getUserByReferralCode */ .ST)(code).then(function(res) {
                    if (!res || res.status !== 200) {
                        setFieldError("referral", "Invalid Referral Code");
                    } else {
                        setIsReferralCodeValid(true);
                    }
                }).finally(function() {
                    setIsValidating(false);
                });
            } catch (error) {
                setFieldError("referral", "Invalid Referral Code");
                setIsValidating(false);
                return false;
            }
        }
    }, 1000, {
        trailing: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default().form),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
            initialValues: defaultValues,
            validationSchema: validation,
            validateOnChange: true,
            onSubmit: onSubmit,
            children: function(param) {
                var _values = param.values, profile_name = _values.profile_name, email = _values.email, team_name = _values.team_name, password = _values.password, dob = _values.dob, confirm = _values.confirm, referral = _values.referral, _errors = param.errors, profileNameError = _errors.profile_name, emailError = _errors.email, teamNameError = _errors.team_name, passwordError = _errors.password, dobError = _errors.dob, confirmError = _errors.confirm, referralError = _errors.referral, touched = param.touched, setFieldValue = param.setFieldValue, setFieldTouched = param.setFieldTouched, isValid = param.isValid, isSubmitting = param.isSubmitting, submitForm = param.submitForm, handleChange = param.handleChange, setFieldError = param.setFieldError;
                var handleReferralChange = function(e) {
                    handleChange(e);
                    if (typeof e !== "undefined") {
                        setIsReferralCodeValid(false);
                        debouncedReferralCodeValidation(e, setFieldError);
                    } else {
                        setIsReferralCodeValid(true);
                    }
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default().formFieldContainer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Email",
                                    placeholder: "Email",
                                    value: email,
                                    onBlur: function() {
                                        return setFieldTouched("email");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("email");
                                        setFieldValue("email", e);
                                    },
                                    inputOptions: {
                                        name: "email "
                                    }
                                }),
                                emailError && touched.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: emailError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Username",
                                    placeholder: "Username",
                                    value: profile_name,
                                    onBlur: function() {
                                        return setFieldTouched("profile_name");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("profile_name");
                                        setFieldValue("profile_name", e);
                                    },
                                    inputOptions: {
                                        name: "profileName "
                                    }
                                }),
                                profileNameError && touched.profile_name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: profileNameError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Team Name",
                                    placeholder: "Team Name",
                                    value: team_name,
                                    onBlur: function() {
                                        return setFieldTouched("team_name");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("team_name");
                                        setFieldValue("team_name", e);
                                    },
                                    inputOptions: {
                                        name: "teamName "
                                    }
                                }),
                                teamNameError && touched.team_name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: teamNameError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                        label: "Date of Birth",
                                        placeholder: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT,
                                        value: dob,
                                        onBlur: function() {
                                            return setFieldTouched("dob");
                                        },
                                        onChange: function(val, e) {
                                            var _$ref;
                                            var _$ref1 = (_$ref = e === null || e === void 0 ? void 0 : e.nativeEvent) !== null && _$ref !== void 0 ? _$ref : {}, inputType = _$ref1.inputType, data = _$ref1.data;
                                            if (inputType === "deleteContentBackward") {
                                                setFieldValue("dob", val);
                                                return;
                                            }
                                            if (!(data === null || data === void 0 ? void 0 : data.match(/^[0-9]+$/g))) return;
                                            var newVal = val;
                                            if (newVal.length === 2 && newVal[newVal.length - 1] !== "/") {
                                                newVal = "".concat(newVal, "/");
                                            }
                                            if (newVal.length === 5 && newVal[newVal.length - 1] !== "/") {
                                                newVal = "".concat(newVal, "/");
                                            }
                                            setFieldValue("dob", newVal);
                                        },
                                        inputOptions: {
                                            name: "dob "
                                        }
                                    }),
                                    dobError && touched.dob && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        message: dobError
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Password",
                                    placeholder: "Password",
                                    type: "password",
                                    value: password,
                                    onBlur: function() {
                                        return setFieldTouched("password");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("psssword");
                                        setFieldValue("password", e);
                                    },
                                    inputOptions: {
                                        name: "password "
                                    }
                                }),
                                passwordError && touched.password && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: passwordError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default().pwInstruct),
                            children: "Must contain 1 number, 1 uppercase, 1 lowercase and a special character (!@#$%^&*)"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Confirm Password",
                                    placeholder: "Confirm Password",
                                    type: "password",
                                    value: confirm,
                                    onBlur: function() {
                                        return setFieldTouched("confirm");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("confirm");
                                        setFieldValue("confirm", e);
                                    },
                                    inputOptions: {
                                        name: "confirmPassword "
                                    }
                                }),
                                confirmError && touched.confirm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: confirmError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_fields_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    label: "Referral Code (optional)",
                                    placeholder: "Referral Code",
                                    value: referral,
                                    onBlur: function(e) {
                                        return setFieldTouched("referral");
                                    },
                                    onChange: function(e) {
                                        setFieldTouched("referral");
                                        setFieldValue("referral", e);
                                        handleReferralChange(e);
                                    },
                                    inputOptions: {
                                        name: "referral "
                                    }
                                }),
                                referralError && touched.referral && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ErrorTag__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    message: referralError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: (styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default().byClickingSignUp),
                                    children: [
                                        'By clicking "Sign up" you agree to the CryptoSports',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/terms",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Terms of Service"
                                                })
                                            })
                                        }),
                                        " ",
                                        "and",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/privacy",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: "Privacy Policy"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fields_button__WEBPACK_IMPORTED_MODULE_3__/* .SlimButton */ .on, {
                                    disabled: isValid === false || isSubmitting || isValidating || !isReferralCodeValid,
                                    text: isSubmitting ? "Submitting..." : "Sign up",
                                    onClick: submitForm,
                                    className: (styles_signup_new_account_module_css__WEBPACK_IMPORTED_MODULE_12___default().formButton)
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}
var referralCodeLength = 6;
var referralCodePattern = new RegExp("^[a-z0-9]{".concat(referralCodeLength, "}$"), "i");
var validation = (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry)().shape({
    email: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().required("Email required").email("Email not valid"),
    profile_name: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().required("Username required"),
    team_name: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().required("Team Name required"),
    dob: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().nullable().required("Date of birth required").test("test-name", "DOB must be in format ".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT), function(e) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(e, _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT);
    }).test("test-old", "Must be 18 years or older", function(e) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(e, _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT, new Date()) <= (0,date_fns__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(new Date(), _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .MIN_AGE */ .G3);
    }).test("real-date", "Date invalid", function(e) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(e, _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .DATE_FORMAT */ .zT, new Date()) >= (0,date_fns__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(new Date(), _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .MAX_AGE */ .w_);
    }),
    password: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().required("Password required").min(8, "Must be 8 or more characters").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, "Must contain 1 number, 1 uppercase, 1 lowercase and a special character (!@#$%^&*)"),
    confirm: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().required("Reenter password").oneOf([
        (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .ref */ .iH)("password")
    ], "Passwords must match"),
    referral: (0,yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_)().min(referralCodeLength, "Invalid Referral Code").max(referralCodeLength, "Invalid Referral Code").matches(referralCodePattern, "Invalid Referral Code")
});
var defaultValues = {
    email: "",
    profile_name: "",
    team_name: "",
    dob: null,
    password: "",
    confirm: "",
    referral: ""
};


/***/ }),

/***/ 47329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cp": function() { return /* binding */ changePassword; },
/* harmony export */   "VQ": function() { return /* binding */ signUpAccount; },
/* harmony export */   "Wp": function() { return /* binding */ getAuthCode; },
/* harmony export */   "ck": function() { return /* binding */ updateProfile; },
/* harmony export */   "ho": function() { return /* binding */ requestCode; },
/* harmony export */   "oP": function() { return /* binding */ validateRecaptchaToken; },
/* harmony export */   "sH": function() { return /* binding */ confirmAuthCode; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5706);



function requestCode(email) {
    return _requestCode.apply(this, arguments);
}
function _requestCode() {
    _requestCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(email) {
        var request, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/forgot-password/request", {
                            email: email
                        })
                    ];
                case 1:
                    request = _state.sent();
                    return [
                        2,
                        request.data
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _requestCode.apply(this, arguments);
}
function changePassword(code, email, password) {
    return _changePassword.apply(this, arguments);
}
function _changePassword() {
    _changePassword = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(code, email, password) {
        var pwd, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/forgot-password/change", {
                            code: code,
                            email: email,
                            password: password
                        })
                    ];
                case 1:
                    pwd = _state.sent();
                    return [
                        2,
                        pwd.data
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _changePassword.apply(this, arguments);
}
function updateProfile(_) {
    return _updateProfile.apply(this, arguments);
}
function _updateProfile() {
    _updateProfile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var profile_name, team_name, birthdate, email, res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    profile_name = param.profile_name, team_name = param.team_name, birthdate = param.birthdate, email = param.email;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/profile", {
                            profile_name: profile_name,
                            team_name: team_name,
                            dob: birthdate,
                            email: email
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        {
                            success: res.data.success
                        }
                    ];
                case 3:
                    err = _state.sent();
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _updateProfile.apply(this, arguments);
}
function signUpAccount(fields) {
    return _signUpAccount.apply(this, arguments);
}
function _signUpAccount() {
    _signUpAccount = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(fields) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/signup", fields)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _signUpAccount.apply(this, arguments);
}
function getAuthCode(email) {
    return _getAuthCode.apply(this, arguments);
}
function _getAuthCode() {
    _getAuthCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(email) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/code", {
                            email: email
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getAuthCode.apply(this, arguments);
}
function confirmAuthCode(email, code) {
    return _confirmAuthCode.apply(this, arguments);
}
function _confirmAuthCode() {
    _confirmAuthCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(email, code) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/auth/confirm", {
                            code: code,
                            email: email
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        {
                            success: res.data.success
                        }
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _confirmAuthCode.apply(this, arguments);
}
function validateRecaptchaToken(token, action) {
    return _validateRecaptchaToken.apply(this, arguments);
}
function _validateRecaptchaToken() {
    _validateRecaptchaToken = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(token, action) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.post */ .v.post("/api/recaptcha", {
                            token: token,
                            action: action
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _validateRecaptchaToken.apply(this, arguments);
}


/***/ }),

/***/ 52694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ getReferrals; },
/* harmony export */   "PR": function() { return /* binding */ getUser; },
/* harmony export */   "ST": function() { return /* binding */ getUserByReferralCode; },
/* harmony export */   "bG": function() { return /* binding */ getUserInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5706);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19911);




function getUser() {
    return _getUser.apply(this, arguments);
}
function _getUser() {
    _getUser = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios.get */ .o.get("/api/v2/user/myProfile")
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        (ref = data.data) === null || ref === void 0 ? void 0 : ref.user
                    ];
            }
        });
    });
    return _getUser.apply(this, arguments);
}
function getUserInfo(userId) {
    return _getUserInfo.apply(this, arguments);
}
function _getUserInfo() {
    _getUserInfo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(userId) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.get */ .v.get("/api/v2/user/".concat(userId))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getUserInfo.apply(this, arguments);
}
function getUserByReferralCode(referralCode) {
    return _getUserByReferralCode.apply(this, arguments);
}
function _getUserByReferralCode() {
    _getUserByReferralCode = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(referralCode) {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.get */ .v.get("/api/v2/user/referral/".concat(referralCode)).catch(function(error) {
                            console.log(error);
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getUserByReferralCode.apply(this, arguments);
}
function getReferrals() {
    return _getReferrals.apply(this, arguments);
}
function _getReferrals() {
    _getReferrals = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var res, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _utils_newAxios__WEBPACK_IMPORTED_MODULE_0__/* .axiosAuth.get */ .v.get("/api/v2/user/referral")
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getReferrals.apply(this, arguments);
}


/***/ }),

/***/ 19911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ axios; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6154);

var axios = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create();


/***/ }),

/***/ 5706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ axiosAuth; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6154);

var axios = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "/",
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true"
    }
});
axios.interceptors.request.use(function(config) {
    var crypto_league = localStorage.getItem("crypto_league");
    if (crypto_league) {
        // config.baseURL = `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/v1/${crypto_league}`
        config.baseURL = "/api/v2/".concat(crypto_league);
    }
    return config;
}, function(error) {
    Promise.reject(error);
});
var axiosAuth = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "/",
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (axios);


/***/ }),

/***/ 45020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"svg":"Currency_svg__VdRpa"};

/***/ }),

/***/ 65787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__E_Uzl","space":"footer_space__k_LTO"};

/***/ }),

/***/ 1389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__3QO8o","content":"layout_content__w92gD","wrapper":"layout_wrapper__4LQCZ","loadingContainer":"layout_loadingContainer__6TFTR"};

/***/ }),

/***/ 64074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"misc_page__pJKhp","titleGroup":"misc_titleGroup__J_Vn0","header":"misc_header__tJshv","tagline":"misc_tagline__PiLQP","button":"misc_button__4A35U","backButton":"misc_backButton__BX4PV","blueButton":"misc_blueButton__V6GV9","backIcon":"misc_backIcon__n9e_N","slimButton":"misc_slimButton__jcpDP","inputLabel":"misc_inputLabel__2QgPm","input":"misc_input__LSDvW","inputWithIcon":"misc_inputWithIcon__p_n9o","inputCurrency":"misc_inputCurrency__9DCtF","borderless":"misc_borderless__ky_nX","percentageIcon":"misc_percentageIcon__SvZMF","button_fit":"misc_button_fit__NFg9J","error":"misc_error__r3kpt","hasIcon":"misc_hasIcon__j3wXy","isOutline":"misc_isOutline__Haufu","noBorder":"misc_noBorder__RUbls","inputSubtitle":"misc_inputSubtitle__s3_nF"};

/***/ }),

/***/ 61580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"new-account_form__Vsyr2","formFieldContainer":"new-account_formFieldContainer__QvO4U","formButton":"new-account_formButton__S_W2y","tAndCCheckbox":"new-account_tAndCCheckbox__qTdVx","pwInstruct":"new-account_pwInstruct__GMMEd","byClickingSignUp":"new-account_byClickingSignUp__Ecggr"};

/***/ }),

/***/ 5079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginContent":"signup_loginContent__FTCur","titleGroup":"signup_titleGroup__lIZxW","banner":"signup_banner___7Knh","card":"signup_card__TbvF7","bar":"signup_bar__g3HBF","left":"signup_left__wrhHa","right":"signup_right__DZdRG","signupDivider":"signup_signupDivider__2EJmH","line":"signup_line__wBEbM","instruction":"signup_instruction__z98VC","buttonGroup":"signup_buttonGroup__EmYer","signupButton":"signup_signupButton__IFTy_","emailSignupButton":"signup_emailSignupButton__xU8rt","googleSignupButton":"signup_googleSignupButton__HqIvo","appleSignupButton":"signup_appleSignupButton__i_2au","promptContainer":"signup_promptContainer__yA6GZ","prompt":"signup_prompt__AATLs","promptLink":"signup_promptLink__m7ATQ","centerError":"signup_centerError__7f7fP","logoSvg":"signup_logoSvg__Q0ibm"};

/***/ }),

/***/ 769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toastContainer":"toast_toastContainer__JAgO0","closeIcon":"toast_closeIcon__oXwef"};

/***/ })

}]);